"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setTransTablePropsFunc = setTransTablePropsFunc;
exports.jsonTableInitState = exports.jsonTableExtraProps = exports.transTablePropsChainList = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _vue = _interopRequireDefault(require("vue"));

var _utils = require("../utils");

var _antDesignVue = require("ant-design-vue");

var _locale = require("../locale");

var _formApi = require("../apis/formApi");

var _lodash = require("lodash");

var _formModal = require("../formModal");

var _xlsx = require("../utils/xlsx");

var _transformLang = require("../utils/transformLang");

var _fieldType = require("../fieldType");

var _advanceFilter = require("./advanceFilter");

var _showCols = require("./showCols");

var _fullScreenTable = require("./fullScreenTable");

var _vueJsonView = require("vue-json-view");

var _jsonComponent = require("../common/jsonComponent");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var transTablePropsChainList = [];
exports.transTablePropsChainList = transTablePropsChainList;
var jsonTableExtraProps = {};
exports.jsonTableExtraProps = jsonTableExtraProps;
var jsonTableInitState = {};
exports.jsonTableInitState = jsonTableInitState;
var defaultColumnWidth = 100;

function setTransTablePropsFunc(func, props, initState) {
  transTablePropsChainList.push(func);

  if (props) {
    Object.assign(jsonTableExtraProps, props);
  }

  if (initState) {
    Object.assign(jsonTableInitState, initState);
  }
}

function filterHiddenColumns(tableProps, props, state) {
  var columns = tableProps.columns;
  var _props$actions = props.actions,
      actions = _props$actions === void 0 ? [] : _props$actions;
  var result = [];

  if (!actions.includes('showCols')) {
    return tableProps;
  }

  var showColumns = (0, _utils.getShowFields)(props.formId, columns);

  if (state.cacheShowColumns !== columns) {
    state.cacheShowColumns = columns;
    state.showColumns = showColumns;
  }

  columns.forEach(function (col) {
    if (col.children && Array.isArray(col.children)) {
      var children = col.children.filter(function (c) {
        return showColumns.includes((col.dataIndex || col.key) + '.' + (c.dataIndex || c.key));
      }); // 有子属性

      if (children.length) {
        result.push(_objectSpread(_objectSpread({}, col), {}, {
          children: children
        }));
      }
    } else if (showColumns.includes(col.dataIndex || col.key)) {
      result.push(col);
    }
  });
  return _objectSpread(_objectSpread({}, tableProps), {}, {
    columns: result
  });
}

function addEllipsis2Columns(tableProps, props) {
  if (!props.ellipsis) {
    return tableProps;
  }

  var columns = tableProps.columns;

  var addEllipsis = function addEllipsis(col) {
    return _objectSpread(_objectSpread({}, col), {}, {
      width: col.width || defaultColumnWidth,
      ellipsis: true,
      customHeaderCell: function customHeaderCell() {
        return {
          attrs: {
            title: col.title
          }
        };
      }
    });
  };

  var newColumns = columns.map(function (col) {
    if (col.children && Array.isArray(col.children)) {
      return _objectSpread(_objectSpread({}, addEllipsis(col)), {}, {
        children: col.children.map(addEllipsis)
      });
    }

    return addEllipsis(col);
  });
  return _objectSpread(_objectSpread({}, tableProps), {}, {
    columns: newColumns
  });
} // 删除操作


function confirmDelete(component) {
  var $props = component.$props,
      state = component.state;
  return function (id) {
    _antDesignVue.Modal.confirm({
      title: (0, _locale.tl)('showTable.confirmDel'),
      onOk: function onOk() {
        var deleteApi = $props.deleteApi || _formApi.FormApi.deleteData;
        component.loading = true;
        state.visible = false;
        deleteApi($props.formId, id).then(function () {
          _antDesignVue.message.success((0, _locale.tl)('showTable.delSuccess')); // 修复最后一页最后一条被删除的问题


          var _component$factPagina = component.factPagination,
              pageSize = _component$factPagina.pageSize,
              total = _component$factPagina.total,
              current = _component$factPagina.current;

          if (total % pageSize === 1 && current === Math.ceil(total / pageSize)) {
            component.onTableChange({
              current: current > 1 ? current - 1 : current,
              pageSize: pageSize
            });
          } else {
            component.getList();
          }
        });
      }
    });
  };
}

function handleSubmit(component) {
  var state = component.state;
  var props = component.$props;
  return function (values) {
    var silent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var addApi = props.addApi || _formApi.FormApi.addData;
    var editApi = props.editApi || _formApi.FormApi.editData;

    if (state.mode === 'add') {
      addApi(component.formId, values).then(function () {
        state.visible = false;

        _antDesignVue.message.success((0, _locale.tl)('showTable.addSuccess'));

        component.getList({
          silent: silent
        });
      }).catch(function () {});
    } else if (state.mode === 'edit') {
      editApi(component.formId, _objectSpread(_objectSpread({}, values), {}, (0, _defineProperty2.default)({}, props.rowKey, state.currentRecord[props.rowKey]))).then(function () {
        state.visible = false;

        _antDesignVue.message.success((0, _locale.tl)('showTable.updateSuccess'));

        component.getList({
          silent: silent
        });
      }).catch(function () {});
    }
  };
}

function addModalAndAddAction2Table(tableProps, props, state, component) {
  var _props$actions2 = props.actions,
      actions = _props$actions2 === void 0 ? [] : _props$actions2;

  var showModal = function showModal(mode) {
    return function (record) {
      state.currentRecord = (0, _lodash.cloneDeep)(record || {});
      state.visible = true;
      state.mode = mode;
    };
  };

  if (actions.some(function (a) {
    return a === 'edit' || a === 'view' || a === 'viewLine' || a === 'add';
  })) {
    // 初始化数据
    var children = [];

    if (actions.includes('edit')) {
      children.push(component.$createElement('span', {
        on: {
          click: function click() {
            return state.mode = 'edit';
          }
        },
        slot: 'actions'
      }, [component.$createElement('a-icon', {
        props: {
          type: 'edit',
          theme: 'filled'
        }
      }), (0, _locale.tl)('showTable.edit')]));
    }

    if (actions.includes('delete')) {
      children.push(component.$createElement('span', {
        on: {
          click: function click() {
            return confirmDelete(component)(state.currentRecord._id);
          }
        },
        slot: 'actions'
      }, [component.$createElement('a-icon', {
        props: {
          type: 'delete',
          theme: 'filled'
        }
      }), (0, _locale.tl)('showTable.del')]));
    }

    tableProps.actions.push(component.$createElement(_formModal.FormModal, {
      props: {
        visible: state.visible,
        mode: state.mode,
        filterType: state.mode === 'view' ? props.viewFilterType : props.formFilterType,
        json: component.privateJson || component.json,
        data: state.currentRecord,
        handleSubmit: handleSubmit(component)
      },
      on: {
        cancel: function cancel() {
          return state.visible = false;
        }
      }
    }, children));
  } // 添加顶部 添加按钮


  if (actions.includes('add')) {
    tableProps.actions.push(component.$createElement('a-button', {
      props: {
        type: 'primary'
      },
      on: {
        click: function click() {
          return showModal('add')();
        }
      },
      style: 'margin-right: 12px;'
    }, [component.$createElement('a-icon', {
      props: {
        type: 'plus-circle',
        theme: 'filled'
      }
    }), (0, _locale.tl)('showTable.add')]));
  }

  return tableProps;
}

function addExportAndImport(tableProps, props, state, component) {
  var _props$actions3 = props.actions,
      actions = _props$actions3 === void 0 ? [] : _props$actions3;

  if (actions.includes('import')) {
    var importExcel = function importExcel(_ref) {
      var file = _ref.file;
      state.importLoading = true;
      (0, _xlsx.importXlsx)(file, (0, _transformLang.transformLang)(component.beforeFormItems, 'zh', true)).finally(function () {
        return state.importLoading = false;
      });
    };

    tableProps.actions.push(component.$createElement('a-upload', {
      props: {
        customRequest: importExcel,
        showUploadList: false,
        disabled: state.importLoading
      }
    }, [component.$createElement('a-button', {
      props: {
        loading: state.importLoading
      },
      style: 'margin-right: 12px;'
    }, (0, _locale.tl)('showTable.import'))]));
  }

  var exportExcel = function exportExcel() {
    state.exportLoading = true;
    return component.getList({
      onlyGet: true,
      size: 99999,
      current: 1
    }).then(function (data) {
      var dataSource = _fieldType.FieldType.transDataByType(data || [], component.formItems);

      (0, _xlsx.exportXlsx)(component.formItems, dataSource, {
        fileName: component.formProperty.enName + '.xlsx',
        border: true
      });
    }).finally(function () {
      state.exportLoading = false;
    });
  }; // 为了可以使用 ref 导出 excel


  component.exportExcel = exportExcel;

  if (actions.includes('export')) {
    tableProps.actions.push(component.$createElement('a-button', {
      props: {
        loading: state.exportLoading
      },
      on: {
        click: exportExcel
      }
    }, [(0, _locale.tl)('showTable.export')]));
  }

  return tableProps;
}

function addActions2Columns(tableProps, props, state, component) {
  var _tableProps$columns = tableProps.columns,
      columns = _tableProps$columns === void 0 ? [] : _tableProps$columns;
  var _props$actions4 = props.actions,
      actions = _props$actions4 === void 0 ? [] : _props$actions4,
      actionRender = props.actionRender,
      rowKey = props.rowKey;
  var rightActionsLength = actions.filter(function (a) {
    return a === 'view' || a === 'edit' || a === 'delete';
  }).length;

  var showModal = function showModal(mode) {
    return function (record) {
      state.currentRecord = (0, _lodash.cloneDeep)(record || {});
      state.visible = true;
      state.mode = mode;
    };
  };

  var actionObj = {
    delete: confirmDelete(component),
    edit: showModal('edit'),
    view: showModal('view'),
    getList: function getList() {
      return component.getList();
    }
  };
  var result = columns.slice();

  if (actionRender) {
    result.push(actionRender(component.$createElement, actionObj));
  } else if (rightActionsLength) {
    result.push({
      title: (0, _locale.tl)('showTable.action'),
      key: 'action',
      fixed: 'right',
      width: rightActionsLength * 50 + 15,
      customRender: function customRender(record) {
        var acts = [];

        if (actions.includes('view')) {
          acts.push(component.$createElement('a', {
            on: {
              click: function click() {
                return actionObj.view(record);
              }
            }
          }, [(0, _locale.tl)('showTable.view')]));
        }

        if (actions.includes('edit')) {
          acts.push(component.$createElement('a', {
            on: {
              click: function click() {
                return actionObj.edit(record);
              }
            }
          }, [(0, _locale.tl)('showTable.edit')]));
        }

        if (actions.includes('delete')) {
          acts.push(component.$createElement('a', {
            on: {
              click: function click() {
                return actionObj.delete(record[rowKey]);
              }
            }
          }, [(0, _locale.tl)('showTable.del')]));
        }

        var out = [];
        acts.forEach(function (a, i) {
          out.push(a);

          if (i !== acts.length - 1) {
            out.push(component.$createElement('a-divider', {
              props: {
                type: 'vertical'
              }
            }));
          }
        });
        return out;
      }
    });
  }

  return _objectSpread(_objectSpread({}, tableProps), {}, {
    columns: result
  });
}

function addDefaultScrollX(tableProps, props, state) {
  var _props$scroll, _props$scroll2;

  if (state.cacheColumns !== tableProps.columns) {
    var reduceCalcSum = function reduceCalcSum(total, col) {
      if (col.children && Array.isArray(col.children)) {
        return total + col.children.reduce(reduceCalcSum, 0);
      }

      return total + (col.width || defaultColumnWidth);
    };

    state.defaultScrollX = tableProps.columns.reduce(reduceCalcSum, 0);
    state.cacheColumns = tableProps.columns;
  }

  return _objectSpread(_objectSpread({}, tableProps), {}, {
    scroll: (_props$scroll = props.scroll) !== null && _props$scroll !== void 0 && _props$scroll.x ? props.scroll : {
      x: state.defaultScrollX,
      y: (_props$scroll2 = props.scroll) === null || _props$scroll2 === void 0 ? void 0 : _props$scroll2.y
    }
  });
}

function addFullScreenModal(tableProps, props, state, component) {
  var _props$actions5 = props.actions,
      actions = _props$actions5 === void 0 ? [] : _props$actions5;

  if (actions.includes('fullScreen') && !state.fullScreenVisible) {
    var onShowFullTable = function onShowFullTable() {
      state.fullScreenDataSource = [];
      state.fullScreenVisible = true;
      state.fullScreenLoading = true;
      component.getList({
        onlyGet: true,
        size: 99999,
        current: 1
      }).then(function (data) {
        return state.fullScreenDataSource = _fieldType.FieldType.transDataByType(data, component.formItems);
      }).finally(function () {
        return state.fullScreenLoading = false;
      });
    };

    tableProps.rightActions.splice(0, 0, component.$createElement('span', {
      on: {
        click: onShowFullTable
      },
      class: 'json-table-actions-text'
    }, [component.$createElement('a-icon', {
      props: {
        type: 'tablet',
        theme: 'filled'
      },
      class: 'json-table-primary-icon'
    }), (0, _locale.tl)('fullScreen.title')]));
  }

  if (state.fullScreenVisible) {
    var onModalClose = function onModalClose() {
      state.fullScreenVisible = false;
      component.getList();
    };

    return _objectSpread(_objectSpread({}, tableProps), {}, {
      tag: _fullScreenTable.FullScreenTable,
      visible: true,
      dataSource: props.fixedLastLine ? state.fullScreenDataSource.slice(0, -1) : state.fullScreenDataSource,
      footerData: props.fixedLastLine ? state.fullScreenDataSource.slice(-1)[0] : undefined,
      renderSize: 40,
      loading: state.fullScreenLoading,
      on: {
        change: onModalClose
      }
    });
  }

  return tableProps;
}

function addFilterModal(tableProps, props, state, component) {
  var _props$actions6 = props.actions,
      actions = _props$actions6 === void 0 ? [] : _props$actions6;

  if (actions.includes('filter')) {
    var onFilterFieldChange = function onFilterFieldChange(fields) {
      state.filter = fields;
      component.onTableChange({
        current: 1,
        pageSize: component.factPagination.pageSize
      });
    };

    tableProps.rightActions.push(component.$createElement(_advanceFilter.AdvanceFilter, {
      props: {
        json: component.privateJson || component.json,
        initValue: state.filter
      },
      on: {
        change: onFilterFieldChange
      },
      style: 'margin-left: 12px;'
    }));
  }

  return tableProps;
}

function addShowColsModal(tableProps, props, state, component) {
  var _props$actions7 = props.actions,
      actions = _props$actions7 === void 0 ? [] : _props$actions7;

  if (actions.includes('showCols')) {
    tableProps.rightActions.push(component.$createElement(_showCols.ShowCols, {
      props: {
        json: component.privateJson || component.json,
        value: state.showColumns
      },
      on: {
        change: function change(columns) {
          (0, _utils.setShowFields)(component.formId, columns);
          state.showColumns = columns;
        }
      },
      style: 'margin-left: 12px;'
    }));
  }

  return tableProps;
}

function transJsonTextCell2Dom(tableProps, props, state, component) {
  var columns = tableProps.columns.map(function (col) {
    var customRender = function customRender(text, record, index) {
      var result = col.customRender(text, record, index);

      var isVNode = function isVNode(obj) {
        return obj instanceof component.$createElement('div').constructor;
      };

      if (Array.isArray(result)) {
        return result.some(function (t) {
          return isVNode(t);
        }) ? result : _vueJsonView.VueJsonView.ele2VNode(component.$createElement, result, record);
      }

      return isVNode(result) ? result : _vueJsonView.VueJsonView.ele2VNode(component.$createElement, result, record);
    };

    return _objectSpread(_objectSpread({}, col), {}, {
      customRender: col.customRender ? customRender : undefined
    });
  });
  return _objectSpread(_objectSpread({}, tableProps), {}, {
    columns: columns
  });
}

function dealWithChildrenForm(tableProps) {
  var cacheDataSourceRowSpan = tableProps.dataSource;
  var columns = tableProps.columns.map(function (col) {
    var customRender = function customRender(text, record, index) {
      var rowSpan = record[(col.dataIndex || col.key) + '_rowSpan'] || record.rowSpan || 0;

      if (index === 0 && !rowSpan && cacheDataSourceRowSpan) {
        cacheDataSourceRowSpan.every(function (row) {
          var rs = row[(col.dataIndex || col.key) + '_rowSpan'] || row.rowSpan || 0;

          if (rs === 0) {
            rowSpan++;
          }

          return rs === 0;
        });
        return {
          attrs: {
            rowSpan: rowSpan
          }
        };
      }

      var children = col.customRender ? col.customRender(text, record, index) : text;
      return {
        attrs: {
          rowSpan: rowSpan,
          title: typeof children === 'string' ? children : ''
        },
        children: children
      };
    };

    return _objectSpread(_objectSpread({}, col), {}, {
      customRender: customRender
    });
  });
  return _objectSpread(_objectSpread({}, tableProps), {}, {
    columns: columns
  });
}

function addEditInlineCell(tableProps, props, state, component) {
  if (!props.actions.includes('editLine') || !component.json && !component.privateJson) {
    return tableProps;
  } // 获取 表单的 formItems


  var form = JSON.parse(component.json || component.privateJson);
  var formFormItems = form.children || [];
  var show = form._show || {};
  var filterList = show[props.formFilterType || 'form'] || [];
  formFormItems = (0, _jsonComponent.filterFormItems)(formFormItems, filterList);
  formFormItems = (0, _transformLang.transformLang)(formFormItems, (0, _locale.getLang)(), true);
  var rowKey = props.rowKey;
  var columns = tableProps.columns.map(function (column) {
    var item = formFormItems.find(function (i) {
      return i.name === column.dataIndex;
    });

    if (!item || item._notEditable || item._type !== 'string' && item._type !== 'number') {
      return column;
    }

    var customRender = function customRender(text, record, index) {
      if (record[rowKey] !== state.editCell.rowKey) {
        return column.customRender ? column.customRender(text, record, index) : text;
      }

      var onInputChange = function onInputChange(e) {
        if (e !== null && e !== void 0 && e.target) {
          var _e$target;

          _vue.default.set(record, column.dataIndex, e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value);
        } else {
          _vue.default.set(record, column.dataIndex, e);
        }
      };

      var onInputBlur = function onInputBlur() {
        state.editCell = {
          dataIndex: '',
          rowKey: ''
        };

        if (record[column.dataIndex] !== state.currentRecord[column.dataIndex]) {
          handleSubmit(component)(_objectSpread(_objectSpread({}, state.currentRecord), {}, (0, _defineProperty2.default)({}, column.dataIndex, record[column.dataIndex])), true);
        }
      };

      return _objectSpread(_objectSpread({}, item.children), {}, {
        value: record[column.dataIndex],
        on: {
          change: onInputChange,
          blur: onInputBlur
        },
        ref: "_json_table_".concat(column.dataIndex)
      });
    };

    var customCell = function customCell(record) {
      if (record._notEditableLine || state.editCell.dataIndex === column.dataIndex && state.editCell.rowKey === record[rowKey]) {
        return {};
      }

      var handleClick = function handleClick() {
        state.editCell = {
          dataIndex: column.dataIndex,
          rowKey: record[rowKey]
        };
        state.currentRecord = (0, _lodash.cloneDeep)(record || {});
        state.mode = 'edit';
        component.$nextTick(function () {
          var _component$$refs$, _component$$refs$$foc;

          (_component$$refs$ = component.$refs["_json_table_".concat(column.dataIndex)]) === null || _component$$refs$ === void 0 ? void 0 : (_component$$refs$$foc = _component$$refs$.focus) === null || _component$$refs$$foc === void 0 ? void 0 : _component$$refs$$foc.call(_component$$refs$);
        });
      };

      return {
        style: {
          cursor: 'pointer'
        },
        on: {
          click: handleClick
        }
      };
    };

    return _objectSpread(_objectSpread({}, column), {}, {
      customRender: column.dataIndex === state.editCell.dataIndex ? customRender : column.customRender,
      customCell: customCell
    });
  });
  return _objectSpread(_objectSpread({}, tableProps), {}, {
    columns: columns
  });
}

function dealWithTransColumnsProps(tableProps, props, state) {
  var columns = tableProps.columns;

  if (props.transColumns) {
    columns = props.transColumns(columns);
  }

  state.factColumns = columns;
  return _objectSpread(_objectSpread({}, tableProps), {}, {
    columns: columns
  });
}

function addClickViewLine(tableProps, props, state) {
  if (!props.customRow) {
    var customRow = function customRow(record) {
      if (props.actions.includes('viewLine')) {
        var showView = function showView(record) {
          state.currentRecord = (0, _lodash.cloneDeep)(record || {});
          state.visible = true;
          state.mode = 'view';
        };

        return {
          on: {
            click: function click(e) {
              return e.target.nodeName !== 'A' && showView(record);
            }
          }
        };
      }

      return {
        on: {
          click: function click() {
            if (state.activeLine === record[props.rowKey]) {
              state.activeLine = '';
            } else {
              state.activeLine = record[props.rowKey];
            }
          }
        },
        className: {
          'active-line': state.activeLine === record[props.rowKey]
        }
      };
    };

    return _objectSpread(_objectSpread({}, tableProps), {}, {
      customRow: customRow
    });
  }

  return _objectSpread(_objectSpread({}, tableProps), {}, {
    customRow: props.customRow
  });
} // 去掉隐藏列


setTransTablePropsFunc(filterHiddenColumns); // 添加 ellipsis

setTransTablePropsFunc(addEllipsis2Columns, {
  ellipsis: {
    type: Boolean,
    default: false
  }
}); // 添加对话框

setTransTablePropsFunc(addModalAndAddAction2Table, {
  formFilterType: String,
  viewFilterType: String,
  addApi: Function,
  // (authId: string, data: any) => Promise<void>
  deleteApi: Function,
  // (authId: string, id: string) => Promise<void>
  editApi: Function // (authId: string, data: any) => Promise<void>

}, {
  visible: false,
  mode: 'view',
  currentRecord: {}
}); // 添加表格导入导出

setTransTablePropsFunc(addExportAndImport, undefined, {
  exportLoading: false,
  importLoading: false
}); // 添加表格右边操作

setTransTablePropsFunc(addActions2Columns, {
  actionRender: Function
}); // (h: CreateElement, funcObj: IActionFunction) => any;
// 设置 table scroll.x 属性

setTransTablePropsFunc(addDefaultScrollX, {
  scroll: Object
}); // 添加表格筛选

setTransTablePropsFunc(addFilterModal); // 添加编辑列

setTransTablePropsFunc(addShowColsModal, undefined, {
  showColumns: []
}); // 添加行内编辑功能

setTransTablePropsFunc(addEditInlineCell, undefined, {
  editCell: {
    rowKey: '',
    dataIndex: ''
  }
}); // 把 jsonView 的单元格转成 dom

setTransTablePropsFunc(transJsonTextCell2Dom); // 处理子表单

setTransTablePropsFunc(dealWithChildrenForm); // 调用 props transColumns

setTransTablePropsFunc(dealWithTransColumnsProps, {
  transColumns: Function
}); // 添加点击行查看 以及点击行变色

setTransTablePropsFunc(addClickViewLine, {
  customRow: Function
}, {
  activeLine: ''
}); // 添加全屏功能

setTransTablePropsFunc(addFullScreenModal, {
  fixedLastLine: {
    type: Boolean,
    default: false
  }
}, {
  fullScreenDataSource: [],
  fullScreenVisible: false,
  fullScreenLoading: false
});